import React, { FC, useState, useEffect } from 'react'
import styled from 'styled-components'
import { Dialog, DialogTitle, DialogContent, FormControlLabel } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { theme, Text, Row, Space, Icon, Image, Spinner } from 'ui'
import { Edit, Delete, Add, Close, Phone } from '@material-ui/icons'
import { 
    Button, 
    TextField,
    Table, 
    TableBody, 
    TableCell, 
    TableContainer,
    TableRow, 
    TableHead, 
    RadioGroup, 
    Radio, 
    Checkbox, 
    IconButton, 
    Select, 
    InputLabel, 
    MenuItem 
} from '@material-ui/core' 

export const FilterButtonApply = styled(Button)`
  display: inline-flex;
  padding: 7.815px 15.994px 8.179px 15.994px;
  justify-content: center;
  align-items: flex-end;
  gap: 7.386px;
  opacity: 0.5;
`

export const StyledInputContainer = styled.div`
  width: 100%;
`
export const StyledInput = styled.input`
  display: flex;
  width: 100%;
  min-width: 250px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 6px;
  border: 0.909px solid #E2E8F0;
  background: #F8FAFC;
`
export const StyledLabel = styled.div`
  display: flex;
  /*padding-left: 258.452px;*/
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
`
export const StyledRequired = styled.div`
  color: #DC2626;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; 
`
export const StyledSelect = styled.select`
  display: flex;
  width: 100%;
  padding: 14px 10px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 6px;
  border: 0.909px solid #E2E8F0;
  background: #F8FAFC;
`

// Header bar 
export const HeaderImageIcon = styled(Image)`
  width: 16px;
  height: 16px;
`
export const Header = styled.div` 
  display: flex;
  height: 67.983px;
  padding-right: 0;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
`
export const HeaderButtonGroup = styled.div`
  display: flex;
  height: 41.804px;
  align-items: flex-start;
  gap: 11.989px;
`
export const HeaderTitleContainer = styled.div`
  display: flex;
  height: 67.983px;
  flex-direction: column;
  align-items: flex-start;
  gap: 7.997px;
  flex: 1 0 0;
`
export const HeaderMainTitle = styled.div`
  flex: 1 0 0;
  color: #101828;
  text-align: right;
  font-family: Rubik;
  font-size: 30px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px;
`
export const HeaderSecondTitle = styled.div`
  color: #4A5565;
  text-align: right;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`
export const HeaderButton = styled(Button)`
  display: flex;
  padding: 9.634px 16.903px 8.17px 16.903px;
  justify-content: center;
  align-items: center;
  gap: 7.611px;
  border-radius: 8px;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; 
  border-radius: 8px;
  border: 1px solid ${p => p.bcolor};
  color: ${p => p.color};
  background: ${p => p.bg};
`

// Starts Bar
export const StatsBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  margin-top: 15px;
`
export const StatsCard = styled.div`
  display: flex;
  width: 287.997px;
  height: 87.628px;
  padding: 17.813px 17.813px 1.818px 17.813px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  border: 2px solid ${p => p.border};
  background: #FFF;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
  cursor: pointer;
`
export const StatsCardContainer = styled.div`
  display: flex;
  height: 52.003px;
  padding-right: 0;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
`
export const StatsTitleContainer = styled.div`
  display: flex;
  height: 52.003px;
  flex-direction: column;
  align-items: flex-start;
`
export const StatsTitle = styled.div`
  color: #4A5565;
  text-align: right;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
export const StatsCount = styled.div`
  display: flex;
  padding-left: 15.028px;
  flex-direction: column; 
  justify-content: center;
  align-items: center;
  align-self: stretch;
  color: ${p => p.color};
  text-align: right;
  font-family: Rubik;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
`
export const StatsImageIcon = styled(Image)`
  width: 32px;
  height: 32px;
  color: ${p => p.color};
`
export const StatusItemImageIcon = styled(Image)`
  width: 16px;
  height: 16px;
  color: ${p => p.color};
`

// Search Bar
export const SearchBar = styled.div`
  display: flex;
  height: 79.616px;
  padding: 16.903px 16.903px 0.909px 16.903px;
  margin-top: 15px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 0.909px solid #E5E7EB;
  background: #FFF;
`
export const SearchBarContainer = styled.div`
  display: flex;
  justify-content: space-between; 
  align-items: center;
  align-self: stretch;
` 
export const SearchInput = styled(TextField)`
  display: flex;
  margin-left: 10px; 
  width: 100%;
  border-radius: 6px;
  border: 0.909px solid #E2E8F0;
  height: 45.81px;
  background: #F8FAFC;
  align-items: center;
  color: rgba(15, 23, 42, 0.50);
  text-align: right;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  .MuiOutlinedInput-root {
    padding: 0px;
    width 100%;
    height: 46px;
  }

  .MuiOutlinedInput-notchedOutline{
    border: 0px;
  }
`
export const FilterButton = styled(Button)`
  display: flex;
  width: 151.349px;
  height: 45.81px;
  justify-content: center;
  align-items: center;
  gap: 7.997px;
  border-radius: 8px;
  border: 0.909px solid ${p => p.active ? '#8EC5FF' : '#D1D5DC'};
  color: ${p => p.active ? '#1447E6' : '#000000'};
  background: ${p => p.active ? '#EFF6FF' : '#FFF'};
`
// Filter bar
export const FilterImageIcon = styled(Image)`
  color: ${p => p.active ? '#1447E6' : '#000000'};
  width: 16px;
  height: 16px;
`
export const FilterContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 15.994px 16px 15.994px;
  flex-direction: column;
  align-items: flex-start;
  border-top: 0.909px solid #E5E7EB;
  background: #F9FAFB;
`
export const FilterTitle = styled(Button)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  color: #364153;
  text-align: right;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
export const FilterRadioContainer = styled.div`
  display: flex;
  height: 20px;
  align-items: flex-start;
  gap: 15.994px;
  flex-shrink: 0;
  align-self: stretch;
`
export const FilterRadioFormControlLabel = styled(FormControlLabel)`
  & .MuiIconButton-root {
    width: 14px;
    height: 14px;
    margin-left: 3px;
  }

  & .MuiTypography-body1 {
    color: #0F172A;
    text-align: right;
    font-family: Rubik;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
`
export const FilterRadioSelectedTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  color: #6A7282;
  text-align: right;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`
export const FilterInputContainer = styled.div`
  display: flex;
  width: 100%;
  height: 65.81px;
  padding-top: 16px;
  padding-right: 0;
  justify-content: flex-start; 
  align-items: flex-start;
  gap: 15.994px;
`
export const FilterTitleContainer = styled.div`
  display: flex;
  width: 100%;
 
  flex-direction: column;
  align-items: flex-end;
  gap: 7.997px;
`

// Table bar
export const TableBar = styled.div`
  display: flex;
  margin-top: 15px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`
export const TableContainerStyled = styled(TableContainer)`
  max-height: 520px;
`
export const TableHeadStyled = styled(TableHead)`
  position: sticky;
  top: 0;
  z-index: 2;
  border-bottom: 0.909px solid #E2E8F0;
  background: rgba(241, 245, 249, 0.95);
`
export const TableCellTitle = styled.div`
  color: #364153;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`
export const TableCellCategory = styled.div`
  display: flex;
  height: 25.795px;
  width: fit-content;
  margin: 0 auto;
  padding: 4.81px 8.636px 4.986px 8.906px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  border: 1px solid ${p => p.color};
  color: ${p => p.color};
  background: ${p => p.bg};  
`
export const TableCelllOnline = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #155DFC;
`
export const TableCellDescription1 = styled.div`
  color: ${p => p.color};
  font-family: Rubik; 
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
export const TableCellDescription2 = styled.div`
  color: #6A7282;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`
export const TableCellStyled = styled(TableCell)`
  align-items: right;
`
export const TableCellStatus = styled.div`
  display: flex;
  width: fit-content;
  height: 25.795px;
  margin: 0 auto;
  padding: 5px 9px 5px 9px;
  justify-content: center;
  align-items: center;
  gap: 3.585px;
  border-radius: 30504000px;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  border: 1px solid ${p => p.color};
  color: ${p => p.color};
  background: ${p => p.bg};
`